import React from 'react'

import { ServiceContext } from './ServiceContext'
import { ServiceContextControllerProps } from './ServiceContext.types'

export function ServiceContextController({ children, services }: ServiceContextControllerProps) {
  return <ServiceContext.Provider value={services}>{children}</ServiceContext.Provider>
}
